import React from "react";
import { Link } from "gatsby";
import Gallery from "react-grid-gallery";

import Layout from "../components/layout";
import Seo from "../components/Seo";
import BannerLineas from "../components/BannerLineas";
import ProductoRelacionado from "../components/ProductoRelacionado";

import { listArticulos, getArticulo, getRelacionados } from "../utils/articulos";

import "../assets/css/lucero.css";

const imgArticulos = [];
listArticulos("bazar").forEach(a => {
  imgArticulos.push({
    src: a.img,
    thumbnail: a.img,
    thumbnailWidth: a.width ? a.width : 266,
    thumbnailHeight: 178,
    thumbnailCaption: "Art. " + a.codigo,
    caption: a.descripcion,
    alt: a.descripcion,
  });
});
const relacionados = getRelacionados("infantil");

const LineaBazar = props => (
  <Layout>
    <Seo
      title="Línea Bazar"
      description="Línea bazar de Plásticos Lucero: artículos plásticos para todos los ámbitos del hogar con diseño nacional, fabricación propia y materiales de primera para el canal mayorista."
      image={getArticulo("bazar", "700-703").img}
      path="/bazar"
    />

    <BannerLineas
      title="Linea Bazar"
      subTitle="Para todos los ámbitos del hogar con elegantes diseños y con los mejores materiales de plaza"
      image={getArticulo("bazar", "700-703").img}
    />

    <main id="main">
      <section id="one">
        <div className="content">
          <div className="inner">
            <div
              style={{
                display: "block",
                minHeight: "1px",
                width: "100%",
                border: "1px solid #2A2F4A",
                overflow: "auto",
                textAlign: "center",
                background: "#2A2F4A",
              }}>
              <Gallery
                images={imgArticulos}
                enableImageSelection={false}
                backdropClosesModal={true}
                imageCountSeparator="&nbsp;de&nbsp;"
                showCloseButton={false}
                margin={15}
              />
            </div>
          </div>
        </div>
      </section>
      <section id="catalogoCta">
        <div className="inner" style={{ textAlign: "center" }}>
          <header className="major">
            <h2>Catálogo completo</h2>
          </header>
          <p>
            Descargá el catálogo de productos en PDF. Para precios actualizados, disponibilidad por artículo y mínimos
            de pedido, escribinos por mail o teléfono.
          </p>
          <ul
            className="actions"
            style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 15 }}>
            <li>
              <a href="/catalogo.pdf" className="button special" download>
                Descargar catálogo (PDF)
              </a>
            </li>
          </ul>
        </div>
      </section>

      <section id="moreInfantil">
        <div className="inner">
          <header className="major">
            <h2>Mirá la linea Infantil tambien!</h2>
          </header>
          <div className="grid-wrapper">
            {relacionados.map(pr => (
              <ProductoRelacionado articulo={pr} key={pr.codigo} />
            ))}
          </div>
          <ul
            className="actions"
            style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: 15 }}>
            <li>
              <Link to="/infantil" className="button next">
                VER MAS
              </Link>
            </li>
          </ul>
        </div>
      </section>
    </main>
  </Layout>
);

export default LineaBazar;
